<template>
  <div>
    <p>잠시만 기다려 주세요. 앱으로 이동 중입니다...</p>
    <div class="item-info" @click="openAOSAppOrStore">AOS앱 열기</div>
    <div class="item-info" @click="openIOSAppOrStore">IOS앱 열기</div>
  </div>
</template>

<script>
export default {
  name: "RedirectPageIndex",
  mounted() {
    let userAgent = navigator.userAgent.toLowerCase();
    console.log("-------------->")
    console.log(userAgent)
    if (userAgent.indexOf("android") >= 0) {
      this.openAOSAppOrStore();
    } else {
      this.openIOSAppOrStore();
    }
  },
  computed: {
    checkKakao() {
      let userAgent = navigator.userAgent.toLowerCase();
      return !!userAgent.match(/kakaotalk/i);
    },
  },
  methods: {
    openAOSAppOrStore() {
      this.timeout = setTimeout(() => {
        if (this.checkKakao) {
          window.open(
              'kakaotalk://web/openExternal?url=https://play.google.com/store/apps/details?id=com.ezn.dms.user&hl=ko'
          );
        } else {
          window.location.href = 'https://play.google.com/store/apps/details?id=com.ezn.dms.user&hl=ko';
        }
      }, 2000)
      window.location.href = `dms-user://actions?link=${window.location.origin}/user`;

      window.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "hidden" && this.timeout != null) {
          clearTimeout(this.timeout);
          this.timeout = null;
        }
      });
    },
    openIOSAppOrStore() {
      if (this.checkKakao) {
        window.open(`kakaotalk://web/openExternal?url=${window.location.origin}/user/fo/join/app-store-link`)
      } else {
        window.location.href = `${window.location.origin}/user/fo/join/app-store-link`
      }
      // window.addEventListener("visibilitychange", () => {
      //   if (document.visibilityState === "hidden" && this.timeout != null) {
      //     clearTimeout(this.timeout);
      //     this.timeout = null;
      //   }
      // });
    }
  },
};
</script>
